import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#fdf6ec] flex items-center justify-center p-6" data-testid="payment-cancel-page">
      <div className="bg-white rounded-3xl border border-[#f0e4d4] p-8 max-w-md w-full flex flex-col items-center gap-4 text-center shadow-[0_12px_40px_rgba(232,131,107,0.12)]">
        <XCircle size={48} className="text-[#b8723f]" />
        <h1 data-testid="payment-cancelled" className="text-xl font-extrabold text-[#2b2622]">
          Pagamento annullato
        </h1>
        <p className="text-sm text-[#7a6f64]">
          Nessun addebito è stato effettuato e nessun pacchetto è stato accreditato.
        </p>
        <Button
          data-testid="back-home-btn"
          onClick={() => navigate("/")}
          className="w-full bg-[#e8836b] hover:bg-[#d76f57] text-white rounded-full py-6 font-bold"
        >
          Torna alla Home
        </Button>
      </div>
    </div>
  );
}
